module.exports = __webpack_public_path__ + "static/wapp_conversacion_2833px-bf9884e58d61335188625c96ae2a423b.gif";